export default "__VITE_ASSET__ZOG0NWVf__"